// Swiper slider default styles
import 'swiper/scss';
import 'swiper/scss/pagination';
import 'swiper/scss/navigation';

// Site main styles
import '../scss/style.scss';

import { Alert, Collapse } from 'bootstrap';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

// import { maskPhone } from './utils/inputmask';
import { showModal } from './utils/modal';
import { initSelect } from './utils/custom_select';
import ajax from './utils/ajax';
import { copyToClipboard, scrollTo } from './utils/general';
import { captcha } from './utils/recaptcha';
import { addFieldErrors, clearFieldErrors } from './utils/form';
import MultiFileUploader from './MultiFileUploader';
import GoogleMap from './GoogleMap';
import { addToast } from './utils/toast';

import tplModalSearch from './templates/modal_search.pug';
import tplModalVideo from './templates/modal_video.pug';

import './cookie_consent';
import './lightbox';
import './mobile_menu';
import './product_list';
import './product';
import './sliders';
import './interactive_map';

window.initMapsCallback = () => {
  Array.from(document.querySelectorAll('[data-map]')).forEach(mapEl => new GoogleMap(mapEl));
};

window.addEventListener('DOMContentLoaded', () => {

  // Menubars
  // const searchParams = new URLSearchParams(window.location.search);
  Array.from(document.querySelectorAll('[role="menubar"]')).forEach(menubarEl => {
    const isHeaderMenu = menubarEl.classList.contains('nav-header');
    new CMS.Menu(menubarEl, {
      backdrop: isHeaderMenu,
      // debug: searchParams.has('debug'),
      debugColor: 'rgba(0, 255, 255, .5)',
      onDropdown: (menuEl) => {
        if (
          isHeaderMenu && 
          menuEl &&
          menuEl.hasAttribute('data-level') &&
          parseInt(menuEl.getAttribute('data-level')) === 2
        ) {
          menubarEl.style.setProperty('--nav-dropdown-texture-height', `${menuEl.scrollHeight}px` || 'auto');
        }
      },
    });

    // header menu - single dropdowns
    if (isHeaderMenu) {
      Array.from(menubarEl.querySelectorAll(':scope > [role="none"]')).forEach(menuItemEl => {
        if (menuItemEl.querySelector('[role="menu"]') && !menuItemEl.querySelector('[role="menu"] [role="menu"]')) {
          menuItemEl.classList.add('nav-item-single-dropdown');
        }
      });
    }

    // auto-activate parent menu items in dropdown menus
    const activeLinkEl = menubarEl.querySelector('.nav-link.active');
    if (activeLinkEl) {
      let traverse = true;
      let el = activeLinkEl;

      while(traverse) {
        const menuEl = el.closest('[role="menu"], [role="menubar"]');
        const menuItemEl = (menuEl) ? menuEl.closest('[role="none"]') : null;
        const linkEl = (menuItemEl) ? menuItemEl.querySelector(':scope > [role="menuitem"]') : null;
        if (!linkEl) {
          traverse = false;
          break;
        }
        linkEl.classList.add('active');
        el = linkEl;
      }
    }

    if (isHeaderMenu) {
      CMS.DataStore.dispatch('menu/header', { initMobileMenu: true });
    }

  });

  ScrollTrigger.matchMedia({
    '(min-width: 992px)': () => {

      // // sticky header
      // ScrollTrigger.create({
      //   trigger: '.site-header',
      //   start: 'top top',
      //   // endTrigger: 'body',
      //   // end: 'bottom bottom',
      //   end: 'max',
      //   pin: true,
      //   pinSpacing: false,
      // });

      // // Parallax featured slider
      // if (document.querySelector('[data-slider="featured"]')) {
      //   const sliderFeaturedEl = document.querySelector('[data-slider="featured"]');
      //   const imgEls = sliderFeaturedEl.querySelectorAll('picture img');
      //   ScrollTrigger.create({
      //     trigger: sliderFeaturedEl,
      //     start: 'top top',
      //     end: 'bottom top',
      //     scrub: true,
      //     animation: gsap.fromTo(imgEls, { y: 0 }, { y: '+=30%', ease: 'linear' }),
      //   });
      // }

    },
  });

  // sticky header
  ScrollTrigger.create({
    trigger: '.site-header',
    start: 'top top',
    endTrigger: 'html',
    end: 'bottom top',
    // end: 'max',
    pin: true,
    pinSpacing: false,
  });

  // Scroll-to links and buttons
  Array.from(document.querySelectorAll('[data-scroll-to]')).forEach(btnEl => {
    const targetSelector = btnEl.getAttribute('data-scroll-to');
    btnEl.addEventListener('click', e => {
      e.preventDefault();
      scrollTo(targetSelector);
    }, false);
  });

  // Copy to clipboard links
  Array.from(document.querySelectorAll('[data-copy-to-clipboard]')).forEach(linkEl => {
    linkEl.addEventListener('click', e => {
      e.preventDefault();
      const url = linkEl.getAttribute('href');
      const msg = linkEl.getAttribute('data-copy-to-clipboard');
      copyToClipboard(url)
        .then(() => {
          addToast(msg, {
            theme: 'success',
          });
        });
    }, false);
  });

  // Bootstrap alerts
  Array.from(document.querySelectorAll('.alert')).forEach(alertEl => {
    new Alert(alertEl);
    alertEl.addEventListener('closed.bs.alert', () => {
      if (alertEl.hasAttribute('data-site-alert')) {
        // save closed state for 2 hours
        const expires = new Date(new Date().getTime() + (2 * 60 * 60 * 1000));
        CMS.Cookies.set('site_alert', '1', {
          expires,
        });
      }
    });
  });

  // Bootstrap Collapse blocks
  Array.from(document.querySelectorAll('.collapse')).forEach(collapseEl => {
    const toggle = (collapseEl.hasAttribute('data-auto-toggle')) ? true : false;
    new Collapse(collapseEl, { toggle });
  });

  // // Form validation
  // $('[data-validate]').ajaxValidate();

  // // Phone input mask
  // maskPhone('input[name="phone"]')
  //   .catch(err => console.error(err));

  // // Auto-responsive iframe embeds
  // CMS.responsiveEmbed({
  //   selector: 'iframe',
  // });


  // Custom select elements
  Array.from(document.querySelectorAll('[data-choices]')).forEach(selectEl => {
    initSelect(selectEl, {});
  });
  
  // Auto-responsive tables
  CMS.responsiveTable({
    selector: '.cms-content > table:not(.table)',
  });

  // Search modal
  Array.from(document.querySelectorAll('[data-trigger-search]')).forEach(btnEl => {
    btnEl.addEventListener('click', e => {
      e.preventDefault();

      const modalId = 'modalSearch';
      const html = tplModalSearch({
        id: modalId,
        method: 'get',
        action: Settings.search.formAction,
        inputValue: Settings.search.inputValue,
        i18n: Settings.search.i18n,
      });
      showModal(html, null, {
        id: modalId,
        autofocusElAfter: btnEl,
      });

    }, false);
  });

  // Video player modal
  Array.from(document.querySelectorAll('[data-trigger-video-modal]')).forEach(btnEl => {
    btnEl.addEventListener('click', e => {
      e.preventDefault();
      let videoId = atob(btnEl.getAttribute('data-video')) || null;
      let videoEmbed = null;
      if (videoId && videoId.match(/<iframe/i)) {
        videoEmbed = videoId;
        videoId = null;
      }
      const modalId = 'modalVideo';
      const html = tplModalVideo({
        id: modalId,
        videoId,
        videoEmbed,
        i18n: {
          modal_video_title: Settings.general.i18n.modal_video_title,
        },
      });
      showModal(html, null, {
        id: modalId,
        autofocusElAfter: btnEl,
      });
    }, false);
  });

  // Multi file uploaders
  Array.from(document.querySelectorAll('.multi-file')).forEach(el => {
    new MultiFileUploader(el);
  });

  // Generic form submit
  // Array.from(document.querySelectorAll('[data-slider="multi_step_form"]')).forEach(formEl => {
  Array.from(document.querySelectorAll('[data-generic-form]')).forEach(formEl => {
    formEl.addEventListener('submit', e => {
      e.preventDefault();
      const method = formEl.getAttribute('method');
      const action = formEl.getAttribute('action');
      const submitEl = formEl.querySelector('[type="submit"]');
      const isMultiStepForm = (formEl.hasAttribute('data-slider') && formEl.getAttribute('data-slider') === 'multi_step_form') ? true : false;
      submitEl.disabled = true;

      clearFieldErrors(formEl);

      captcha()
        .then(token => {

          const data = new FormData(formEl);
          data.append('g-recaptcha-response', token);

          ajax({
            method,
            url: action,
            data,
          })
            .then(response => {
              if (response.data.status === 'failure') {
                if (typeof response.data.message === 'object' && typeof response.data.message.fields === 'object') {
                  addFieldErrors(formEl, response.data.message.fields)
                    .then(() => {
                      const firstError = formEl.querySelector('.invalid-feedback');
                      if (isMultiStepForm) {
                        CMS.DataStore.dispatch('multi_step_form/error', {
                          firstError,
                        });
                      } else {
                        scrollTo(firstError.closest('[data-form-field]') || firstError, {
                          offset: 100,
                        });
                      }
                    });
                } else if (typeof response.data.message === 'string') {
                  // generic error
                  addToast(response.data.message);
                }
              } else {
                // success
                window.location.href = `/${response.data.redirect}`;
              }
            })
            .catch(err => {
              console.error(err);
            })
            .finally(() => {
              submitEl.disabled = false;    
            });
        })
        .catch(err => {
          console.error(err);
          submitEl.disabled = false;
        });

    }, false);
  });

});
